import { render, staticRenderFns } from "./BurnedDomains.vue?vue&type=template&id=651cdacc&scoped=true"
import script from "./BurnedDomains.vue?vue&type=script&lang=js"
export * from "./BurnedDomains.vue?vue&type=script&lang=js"
import style0 from "./BurnedDomains.vue?vue&type=style&index=0&id=651cdacc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651cdacc",
  null
  
)

export default component.exports